import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import FormCustomSelectComponent from './js/form-custom-select.component';

ComponentsFactory.getInstance().define('form-custom-select', FormCustomSelectComponent);
